module.exports = __webpack_public_path__ + "assets/img/youmoney.3411343e.svg";